import useDateFormat from '../../../../components/utils/useDateFormat';

export function session(date, event) {
    const [dateWithDay, properTime] = useDateFormat({
        date,
        event,
        timeStyle: 'short'
    });
    return `${dateWithDay} - ${properTime}`;
}
